"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfAdjustmentFactorDto = instanceOfAdjustmentFactorDto;
exports.AdjustmentFactorDtoFromJSON = AdjustmentFactorDtoFromJSON;
exports.AdjustmentFactorDtoFromJSONTyped = AdjustmentFactorDtoFromJSONTyped;
exports.AdjustmentFactorDtoToJSON = AdjustmentFactorDtoToJSON;
exports.AdjustmentFactorDtoToJSONTyped = AdjustmentFactorDtoToJSONTyped;
/**
 * Check if a given object implements the AdjustmentFactorDto interface.
 */
function instanceOfAdjustmentFactorDto(value) {
    if (!('factor' in value) || value['factor'] === undefined)
        return false;
    if (!('impact' in value) || value['impact'] === undefined)
        return false;
    return true;
}
function AdjustmentFactorDtoFromJSON(json) {
    return AdjustmentFactorDtoFromJSONTyped(json, false);
}
function AdjustmentFactorDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'factor': json['factor'],
        'impact': json['impact'],
    };
}
function AdjustmentFactorDtoToJSON(json) {
    return AdjustmentFactorDtoToJSONTyped(json, false);
}
function AdjustmentFactorDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'factor': value['factor'],
        'impact': value['impact'],
    };
}
